export enum TRACKING_EVENT {
  SUBMIT = "tracking.bct.submitEvent",
  ON_NEXT_PI = "tracking.bct.trackOnNextPageImpression",
  CREATE_EVENT_CONTEXT = "tracking.bct.createEventContext",
  ADD_TO_EVENT = "tracking.bct.addToEvent"
}
